import { INTENTIONS } from '@/constants/intentions';
import { V90_OPEN_TO_OPTIONS, V90_RELATIONSHIP_STATUS_OPTIONS } from '@/constants/profileOptions';

/** Discovery preference option ids — match Firestore / seedBerlinMocks intention keys. */

export const DISCOVERY_INTENTION_OPTIONS = INTENTIONS.map(intention => ({
  id: intention.id,
  labelKey: `filters.intentions.options.${intention.id}`,
}));

export const DISCOVERY_OPEN_TO_OPTIONS = V90_OPEN_TO_OPTIONS.map(option => ({
  id: option.toLowerCase(),
  label: option,
}));

export const DISCOVERY_RELATIONSHIP_STATUS_OPTIONS = V90_RELATIONSHIP_STATUS_OPTIONS.map(
  option => ({
    id: option.toLowerCase().replace(/\s+/g, ''),
    label: option,
  })
);

export type DiscoveryGenderMode = 'all' | 'mine';
export type DiscoveryEthnicityMode = 'all' | 'mine';

export const DISCOVERY_DISTANCE_MIN = 1;
export const DISCOVERY_DISTANCE_MAX = 100;
export const DISCOVERY_AGE_MIN = 18;
export const DISCOVERY_AGE_MAX = 100;

/** Number of profiles revealed per "Load more" click in the discovery grid. */
export const DISCOVERY_PAGE_SIZE = 9;

/** Max profiles kept in the discovery pool — bounds how many matching users
 *  are fetched and shown, regardless of how many remain in the area. */
export const DISCOVERY_MAX_PROFILES = 500;
